import { Badge } from '@buffer-mono/popcorn'

import type { JSX } from 'react'

interface ChangelogScheduledBadgeProps {
  publishedAt?: string | Date | null
  size?: 'small' | 'medium'
  className?: string
}

/**
 * Renders a "Scheduled" badge when the entry's publish date is in the future.
 *
 * The backend already hides scheduled entries from non-managers via the
 * `includeScheduled` filter, so reaching this code from a non-manager session
 * is unexpected. The badge is rendered unconditionally for any future date so
 * that any defense-in-depth gating happens at the call site.
 */
export function ChangelogScheduledBadge({
  publishedAt,
  size = 'small',
  className,
}: ChangelogScheduledBadgeProps): JSX.Element | null {
  if (!publishedAt) return null
  const isScheduled = new Date(publishedAt).getTime() > Date.now()
  if (!isScheduled) return null
  return (
    <Badge variant="warning" size={size} className={className}>
      Scheduled
    </Badge>
  )
}
